import React,{useEffect,useRef} from "react";
import Q1 from "../assets/Quote.svg"
import Q2 from "../assets/QuoteWhite.svg"
import line1 from "../assets/Rectangle1.svg"
import line2 from "../assets/Rectangle2.svg"
import DoubleRight from "../assets/DoubleRight.svg"
import TestimonialCarousel from "./TestimonialCarousel";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);


const HomeSec3 = ()=>{

  const Title = useRef(null);
  const head = useRef(null);
  const card = useRef(null);
  const card2 = useRef(null);

  useEffect(() => {
    gsap.set(Title.current, { opacity: 0, y: 100 });
    gsap.set(head.current, { opacity: 0, y: 100 });
    gsap.set(card.current, { opacity: 0, y: 100 });
    gsap.set(card2.current, { opacity: 0, y: 100 });

    gsap.to(Title.current, {
      opacity: 1,
      y: 0,
      duration: 2,
      scrollTrigger: {
        trigger: Title.current,
        start: "top 100%",
        end: "bottom top",
        toggleActions: "play none none reverse",
      },
    });

    gsap.to(head.current, {
      opacity: 1,
      y: 0,
      duration: 2,
      scrollTrigger: {
        trigger: head.current,
        start: "top 100%",
        end: "bottom top",
        toggleActions: "play none none none",
      },
    });

    gsap.to(card.current, {
      opacity: 1,
      y: 0,
      duration: 2,
      scrollTrigger: {
        trigger: card.current,
        start: "top 100%",
        end: "bottom top",
        toggleActions: "play none none none",
      },
    });

    gsap.to(card2.current, {
      opacity: 1,
      y: 0,
      duration: 2,
      scrollTrigger: {
        trigger: card2.current,
        start: "top 100%",
        end: "bottom top",
        toggleActions: "play none none none",
      },
    });
  },[])

    return(

        <section className="bg-black md:pt-0 xl:pt-16 font-guton border-none pb-20">
            <div className="flex flex-col w-90 justify-center mx-auto max-w-[1440px]">
                <h2 ref={head} className="md:text-13 xl:text-21 text-white text-center">Testimonials</h2>
                <p ref={Title} className="text-28 md:text-36  xl:text-64 font-medium text-white text-center leading-24 md:leading-30 xl:leading-55 w-full md:w-65 mx-auto tracking-[-2px] md:tracking-[-3px]">Your Success, Our Motivation <span className="text-red">Hear from Others Like You</span></p>

                <div ref={card} className="hidden md:flex md:space-x-3 xl:space-x-6 mt-14 items-center">
                  {/* 1 */}
                  <div className="md:w-[221px] md:h-[133px] xl:w-2/6 xl:h-235 bg-whiteExtra rounded-xl flex flex-col md:py-2 xl:py-5 px-6">
                    <img className="md:w-4 md:h-4 xl:w-10 xl:h-10" src={Q1} alt="" />
                    <p className="my-2 md:text-11 md:leading-12 xl:leading-20 xl:text-18">Estudy made my Poland study abroad experience stress-free and unforgettable.They helped me achieve my dream of studying overseas.</p>
                    <div className="flex mt-auto">
                      <div className="md:w-7 md:h-7 xl:w-10 xl:h-10 rounded-full bg-black">
                        {/* <img src="" alt="" /> */}
                      </div>
                      <div className="flex-col md:ml-2 xl:ml-4">
                        <p className="font-medium md:text-14 md:leading-14 xl:text-22 xl:leading-21">Salma Khaled</p>
                        <p className="md:text-12 md:leading-14 xl:text-16 xl:leading-14">SAT Student</p>
                      </div>
                    </div>
                  </div>

                  {/* 2 - Taller Box */}
                  <div className="md:w-[252px] md:h-[153px] xl:w-[38%] xl:h-[266px] bg-custom-gradient rounded-xl h-[250px] flex flex-col md:py-2 xl:py-5 px-6">
                    <img className="md:w-8 md:h-8 xl:w-14 xl:h-14" src={Q2} alt="" />
                    <p className="my-2 md:text-12 md:leading-12 xl:leading-20 xl:text-22 text-white">Estudy provided me with a reliable and affordable solution for studying abroad in Poland. Their trusted services made the entire process smooth and stress-free.</p>
                    <div className="flex mt-auto">
                      <div className="md:w-7 md:h-7 xl:w-10 xl:h-10 rounded-full bg-black">
                        {/* <img src="" alt="" /> */}
                      </div>
                      <div className="flex-col md:ml-2 xl:ml-4">
                        <p className="font-medium md:text-14 md:leading-14 xl:text-22 xl:leading-21 text-white">Essam Ahmad</p>
                        <p className="md:text-12 md:leading-14 xl:text-16 xl:leading-14 text-white">Thanawya Amma</p>
                      </div>
                    </div>
                  </div>

                  {/* 3 */}
                  <div className="md:w-[221px] md:h-[133px] xl:w-2/6 xl:h-235 bg-whiteExtra rounded-xl flex flex-col md:py-2 xl:py-5 px-6">
                    <img className="md:w-4 md:h-4 xl:w-10 xl:h-10" src={Q1} alt="" />
                    <p className="my-2 md:text-11 md:leading-12 xl:leading-18 xl:text-18">I am thrilled with the exceptional service provided by Estudy for my Poland study abroad program.</p>
                    <div className="flex mt-auto">
                      <div className="md:w-7 md:h-7 xl:w-10 xl:h-10 rounded-full bg-black">
                        {/* <img src="" alt="" /> */}
                      </div>
                      <div className="flex-col md:ml-2 xl:ml-4">
                        <p className="font-medium md:text-14 md:leading-14 xl:text-22 xl:leading-21">Omar Gamal</p>
                        <p className="md:text-12 md:leading-14 xl:text-16 xl:leading-14">IGCSE Student</p>
                      </div>
                    </div>
                  </div>
                </div>
<TestimonialCarousel />
  {/* How it works */}
<div ref={card2} className="w-full bg-gradient-and-image bg-cover bg-no-repeat mt-20 pt-10 pb-8 md:pb-3 xl:pb-5 md:pt-10 xl:py-10 rounded-xl flex-col">
    <h2 className="text-16 leading-9 md:text-14 md:leading-14 xl:text-24 xl:leading-24 text-white text-center">
        How it Works
    </h2>
    <p className="text-28 leading-26 md:text-36 md:leading-36 xl:text-64 xl:leading-55 font-medium text-white text-center md:mb-1 xl:mb-8 tracking-[-2px]">
        It’s as Easy as <span className="underline decoration-2 underline-offset-8">1 - 2 - 3</span>
    </p>
    <div className="flex flex-col space-y-10 md:space-y-0 md:flex-row md:space-x-3 xl:space-x-8 justify-center md:px-14 xl:px-36 pt-5 md:pb-0 xl:py-10">
        {/* Step 1 */}
        <div className="flex-col w-70 mx-auto md:w-[400px] text-center flex items-center md:items-start md:text-left">
            <div className="w-8 h-8 md:w-8 md:h-8 xl:w-12 xl:h-12 rounded-full bg-white text-center font-semiBold text-24 xl:text-31 text-red">
                1
            </div>
            <p className="text-18 md:tracking-[-0.6px] xl:text-32 font-semiBold text-white mt-4 mb-0 md:my-4">
                Your First Step
            </p>
            <p className="text-12 leading-10 md:text-12 md:leading-10 xl:text-18 text-white xl:leading-18">
                It all starts with a conversation. We get to know your goals—what you want to study, where you’d like to live, and your plans for the future.
            </p>
        </div>
        
        {/* Hidden arrows and lines on small screens */}
        <div className="hidden md:flex flex-col space-y-2 items-center justify-center">
            <img className="md:h-20 xl:h-24" src={line1} alt="" />
            <img className="md:w-14 xl:w-10" src={DoubleRight} alt="" />
            <img className="md:h-20 xl:h-24" src={line2} alt="" />
        </div>

        {/* Step 2 */}
        <div className="flex-col w-70 mx-auto md:w-[400px] text-center flex items-center md:items-start md:text-left">
            <div className="w-8 h-8 md:w-8 md:h-8 xl:w-12 xl:h-12 rounded-full bg-white text-center font-semiBold text-24 xl:text-31 text-red">
                2
            </div>
            <p className="text-18 md:tracking-[-0.6px] xl:text-32 font-semiBold text-white mt-4 mb-0 md:my-4">
                Application
            </p>
            <p className="text-12 leading-10 md:text-12 md:leading-10 xl:text-18 text-white xl:leading-18">
                Our experts help you choose the universities that align with your goals, handle the application process, and ensure all documents are complete.
            </p>
        </div>

        {/* Hidden arrows and lines on small screens */}
        <div className="hidden md:flex flex-col space-y-2 items-center justify-center">
            <img className="md:h-20 xl:h-24" src={line1} alt="" />
            <img className="md:w-14 xl:w-10" src={DoubleRight} alt="" />
            <img className="md:h-20 xl:h-24" src={line2} alt="" />
        </div>

        {/* Step 3 */}
        <div className="flex-col w-55 mx-auto md:w-[400px] text-center flex items-center md:items-start md:text-left">
            <div className="w-8 h-8 md:w-8 md:h-8 xl:w-12 xl:h-12 rounded-full bg-white text-center font-semiBold text-24 xl:text-31 text-red">
                3
            </div>
            <p className="text-18 md:tracking-[-0.6px] xl:text-32 font-semiBold text-white mt-4 mb-0 md:my-4">
                The Big ‘YES’
            </p>
            <p className="text-12 leading-10 md:text-12 md:leading-10 xl:text-18 text-white xl:leading-18">
                Congratulations!!! You’ve been accepted to university! It is time for you to travel.
            </p>
        </div>
    </div>
</div>

            </div>
        </section>
    )
}

export default HomeSec3;